export default __webpack_public_path__ + "static/media/pizzo.dd0374d0.webp";